// Wellness reminders — shared between the Personal Space settings tab and the
// app-wide reminder engine (components/WellnessReminders.js). Purely client-side
// timing; only the per-user preferences live on the server (/api/personal/wellness).

export const WELLNESS_DEFAULTS = {
  paused: false,
  sound_enabled: true,
  water:    { enabled: false, interval: 60 },
  stretch:  { enabled: false, interval: 45 },
  eyes:     { enabled: false, interval: 20 },
  meals:    { enabled: false, times: ['13:00', '20:30'] },
  nudge:    { enabled: false, time: '18:00' },
  hardstop: { enabled: false, hours: 10 },
  myday:    { morning_enabled: false, morning_time: '09:30', item_times_enabled: false },
};

export const REMINDER_META = {
  water:    { title: 'Water break',    message: 'Time for a glass of water 💧', emoji: '💧', sound: true },
  stretch:  { title: 'Stand & stretch', message: 'Stand up, stretch, move around for a minute 🧘', emoji: '🧘', sound: true },
  eyes:     { title: 'Eye rest',       message: '20-20-20: look at something 20 feet away for 20 seconds 👀', emoji: '👀', sound: false },
  meals:    { title: 'Meal time',      message: 'Time to eat — don’t skip your meal 🍽️', emoji: '🍽️', sound: true },
  nudge:    { title: 'Daily wellness nudge', message: 'Day’s done — a short walk or workout goes a long way. Take care of yourself. 🌤️', emoji: '🌤️', sound: true },
  hardstop: { title: 'Long day',       message: 'You’ve been at this a while — consider wrapping up soon 🌙', emoji: '🌙', sound: true },
};

// Soft two-note chime (C5 → E5), generated in-browser — no audio file, low gain
export function playChime() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const now = ctx.currentTime;
    [[523.25, 0], [659.25, 0.18]].forEach(([freq, dt]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, now + dt);
      gain.gain.linearRampToValueAtTime(0.06, now + dt + 0.04);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + dt + 0.7);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + dt);
      osc.stop(now + dt + 0.8);
    });
    setTimeout(() => { try { ctx.close(); } catch {} }, 1500);
  } catch { /* audio blocked or unsupported — reminders stay visual */ }
}
